/**
 * Copyright 2024, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// This implementation works in both browser and react_native environments
import { BrowserRequestHandler } from "../../utils/http_request_handler/request_handler.browser";
import { DefaultEventDispatcher } from './default_dispatcher';
const eventDispatcher = new DefaultEventDispatcher(new BrowserRequestHandler());
export default eventDispatcher;
export const __platforms = ['browser', 'react_native'];
//# sourceMappingURL=default_dispatcher.browser.js.map